module.exports = __webpack_public_path__ + "img/broggi.f3de33dc.png";